module.exports = __webpack_public_path__ + "img/sq4.0e62c251.png";